import { useAppDispatch, useAppSelector } from "~/ui-rtk/app/hooks"
import { chatbotActions } from "~/ui-rtk/app/slices/chatbot.slice"
import { ChatPanel } from "./ChatPanel"

export function ChatButton() {
  const dispatch = useAppDispatch()
  const isPanelOpen = useAppSelector(state => state.chatbotSlice.isPanelOpen)

  return (
    <>
      <ChatPanel />
      <button
        type="button"
        className="chatbot-fab fixed bottom-4 right-4 btn btn-circle bg-system-blue-600 hover:bg-system-blue-500 border-0 shadow-lg z-50"
        onClick={() => dispatch(chatbotActions.togglePanel())}
        title={isPanelOpen ? "Close chat" : "Chat with your data"}
      >
        {isPanelOpen ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="h-6 w-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 0 0-2.455 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
            />
          </svg>
        )}
      </button>
    </>
  )
}
